import request from "superagent";

import { getTabToken } from "common/MetaActions";
import config from "config/config";
import { ArchiveItem } from "models/ArchiveItem";
import { DeliveryFile } from "models/DeliveryFile";
import { DocumentUploadFile } from "models/DocumentUploadFile";

type PreparedUploadResponse = { url: string; fileId: string };

export class ArchiveAPI {
  static async getArchiveFolderFiles(customerId: string, folderId: string) {
    const response = await request
      .get(config.api.archive.getArchiveFolderFiles(customerId, folderId))
      .set("Accept", "application/json")
      .set("Authorization", "Bearer " + getTabToken())
      .send();

    return response.body;
  }

  static async restoreFile(itemId: string, customerId: string) {
    return await request
      .put(config.api.archive.restoreFile(customerId, itemId))
      .set("Accept", "application/json")
      .set("Authorization", "Bearer " + getTabToken())
      .field("fileId", itemId);
  }

  static async markAsDeleted(itemId: string, customerId: string) {
    return await request
      .put(config.api.archive.markAsDeleted(customerId, itemId))
      .set("Accept", "application/json")
      .set("Authorization", "Bearer " + getTabToken())
      .field("fileId", itemId);
  }

  static async fetchArchiveFolders(customerId: string) {
    const response = await request
      .get(config.api.archive.getArchive(customerId))
      .set("Accept", "application/json")
      .set("Authorization", "Bearer " + getTabToken())
      .send();
    return response;
  }

  static async moveInArchive(
    item: ArchiveItem | DeliveryFile,
    customerId: string,
    path: string,
    name: string
  ) {
    return await request
      .put(config.api.archive.moveInArchive(customerId))
      .set("Accept", "application/json")
      .set("Authorization", "Bearer " + getTabToken())
      .send({
        customerId,
        newPath: path,
        fileId: item.id,
        newName: name
      });
  }

  static async getUploadUrls(
    items: DocumentUploadFile[],
    customerId: string,
    path: string
  ) {
    const response = await request
      .post(config.api.archive.uploadToArchive(customerId))
      .set("Accept", "application/json")
      .set("Authorization", "Bearer " + getTabToken())
      .send({
        path: path,
        files: items.map((item) => {
          return {
            ContentLength: item.file.size,
            ContentType: item.file.type,
            FileName: item.file.name
          };
        })
      });

    return response.body;
  }

  static async uploadToS3(
    preparedUploadResponse: PreparedUploadResponse,
    item: DocumentUploadFile
  ) {
    return await request
      .put(preparedUploadResponse.url)
      .set("Content-Type", item.file.type)
      .send(item.file);
  }

}


